import { useLanguage } from "../LanguageContext";

export default function PrivacyPolicyView() {
  const { isAr } = useLanguage();
  const t = (en, ar) => (isAr ? ar : en);

  return (
    <div className="view-enter pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 bg-secondary-50 min-h-screen">
      <div className="max-w-3xl mx-auto">
        <div className="mb-10 sm:mb-12">
          <h3 className="text-primary-700 font-bold tracking-widest uppercase mb-2 text-sm font-display">
            {t("Legal", "قانوني")}
          </h3>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4 font-display">
            {t("Privacy Policy", "سياسة الخصوصية")}
          </h1>
          <div className="h-1 w-12 sm:w-16 rounded-full bg-axion-gold" />
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 md:p-10 space-y-6 sm:space-y-8 text-gray-700 leading-relaxed">
          <div>
            <h2 className="text-xl font-black text-gray-900 mb-3 font-display">
              {t("Your privacy matters", "خصوصيتك تهمنا")}
            </h2>
            <p className="text-gray-600">
              {t(
                "We collect only the information necessary to respond to your inquiries and deliver our services. We do not sell your data.",
                "نجمع فقط المعلومات الضرورية للرد على استفساراتك وتقديم خدماتنا. لا نبيع بياناتك."
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <p className="text-gray-600">
              {t(
                "Information you provide via the contact form (name, email, message) is used solely to follow up on your request.",
                "المعلومات التي تقدمها عبر نموذج التواصل (الاسم والبريد الإلكتروني والرسالة) تُستخدم فقط للمتابعة على طلبك."
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <p className="text-gray-600">
              {t(
                "We implement reasonable administrative and technical safeguards to protect your data.",
                "نطبق ضمانات إدارية وتقنية معقولة لحماية بياناتك."
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6">
            <p className="text-gray-600">
              {t("For any privacy-related questions, contact us at", "لأي أسئلة تتعلق بالخصوصية، تواصل معنا على")}{" "}
              <a href="mailto:info@axionrailway.com" className="font-semibold text-axion-gold">
                info@axionrailway.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
